<template>
  <!-- Skal ligge over Skemaoverblik (.overlay-calendars, z-index 999999991) -->
  <DModal :show-close="false" :appendToBody="true" :zIndex="1000000000" @close="$emit('close')">
    <div class="d-modal__d-calendar text-dark" :class="{'d-modal__d-calendar--with-actions': isShowActions}"
         slot="insertComponent">
      <div class="d-modal__d-calendar__header text-dark">
        <h2>{{ calendar.name }}</h2>
        <div class="d-modal__close icon__bg-circle" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="d-modal__d-calendar__content">
        <div class="d-modal__d-calendar__container">
          <DCalendar
            :calendarId="calendar.id"
            :isShowWeek="false"
            :date="date"
            :events="events"
            :isLoadingEvents="isEventsLoading">
          </DCalendar>
        </div>
        <CalendarViewDayRemoveOrReplace
          v-if="isShowActions"
          :event="event"
          :calendar="calendar"
          :calendars="calendars"
          @updateAndClose="$emit('updateAndClose')">
        </CalendarViewDayRemoveOrReplace>
      </div>
    </div>
  </DModal>
</template>
<script>
import DModal from '../common/DModal'
import DCalendar from '../DCalendar/DCalendar'
import moment from 'moment'
import docendo from '../../docendo'
import CalendarViewDayRemoveOrReplace from './CalendarViewDayRemoveOrReplace'

export default {
  components: {CalendarViewDayRemoveOrReplace, DCalendar, DModal},
  props: {
    calendar: {
      default: {
        id: 7,
        name: 'Henrik R.'
      }
    },
    date: {
      default: '2022-02-21'
    },
    event: {
      default: null,
      type: Object
    },
    calendars: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      events: [],
      isEventsLoading: false
    }
  },
  computed: {
    isShowActions () {
      const calendarTypes = ['user', 'room', 'klass', 'student']
      return this.event && this.calendar && calendarTypes.indexOf(this.calendar.type) > -1
    },
    eventStartFormatted () {
      return moment(this.event.start).format('LL LT')
    }
  },
  methods: {
    readEvents () {
      this.isEventsLoading = true
      let obj = {
        calIds: [this.calendar.id],
        start: moment(this.date).startOf('day'),
        end: moment(this.date).endOf('day')
      }
      docendo.calendarEvents2(obj.calIds, obj.start, obj.end, null,
        data => {
          this.isEventsLoading = false
          this.events = data.length > 0 ? JSON.parse(data) : []
        }, failure => {
          console.log('failure', failure)
        })
    }
  },
  mounted () {
    this.readEvents()
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-modal__d-calendar {
  width: 500px;
  height: 600px;
  max-height: 100vh;
  overflow-y: auto;
  overscroll-behavior-y: contain;
}

.d-modal__d-calendar.d-modal__d-calendar--with-actions {
  width: 750px;
}

.d-modal__d-calendar__header {
  background-color: #ffffff;
  padding: 1rem 2rem;
  justify-content: space-between;
  align-items: center;
  height: 45px;
  border-bottom: 1px solid var(--border-color);
  border-radius: 0.25rem 0.25rem 0 0;
}

.d-modal__d-calendar__content {
  padding: 1rem;
  width: calc(100%);
  height: calc(100% - 45px);
  display: flex;
}

.d-modal__d-calendar__content > div {
  flex: 1;
}

.d-modal__d-calendar__container {
  position: relative;
  width: 100%;
  max-width: 450px;
  min-width: 450px;
}
</style>



// WEBPACK FOOTER //
// CalendarViewDay.vue?99cc25d8